import {dayJS} from "../../../applicationConf";

export const getStateFormCorsi = () => ({
    numeroPagina: 1,
    codice: null,
    descrizione: null,
    codiceFiscaleEnte: null,
    denominazioneEnte: null,
    dataRicerca: dayJS().format('YYYY-MM-DD')
});

export const getNumeroRecordPerPagina = () => 5;
export const getPageRangeDisplayed = () => 7;

